import * as React from "react";
import { memo } from "react";
const SvgCardTitleSlice = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 121, height: 29, viewBox: "0 0 121 29", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 0L126 13.6931V29H0V0Z", fill: "#150501" }));
const Memo = memo(SvgCardTitleSlice);
export default Memo;
